import { oms_url } from '@porterin/feature/src/shared/config/AppConfig';

export const app_download_link = `${oms_url}/app`;
